import { Pagination, Spin } from 'antd';
import { useState } from 'react';
import { useRequest } from 'ahooks';
import {
  bool, object,
} from 'prop-types';
import { isEmpty } from 'lodash';
import FilterType from '@/components/FilterType/FilterType';
import FilterTypeChild from '@/components/FilterType/FilterTypeChild';
import EmptyImg from '@/components/EmptyImg/EmptyImg';
import { getCapitalList } from '@/services/capital';
import CapitalCard from './CapitalCard';
import './CapitalFilter.less';

/**
 * 产品列表组件
 * @param {object} data 数据源
 * @param {bool} isShow 是否显示按钮
 * @param {string} type 类型银行产品\保险产品
 * @param {bool} filter 是否显示筛选条件
 * */
export default function CapitalFilter({
  data, filter,
}) {
  const { area } = data;
  const [list, setList] = useState({});
  const [val, setVal] = useState({});
  const [childArea, setChildArea] = useState([]);

  const { run, loading } = useRequest(getCapitalList, { // 保险产品
    onSuccess(res) {
      setList(res);
    },
  });

  function getData(e) {
    run({ ...e });
  }

  function onChange(page, size) {
    getData({ ...val, pageNum: page, pageSize: size });
  }

  function filterArea(areaID) {
    const matched = area.filter((v) => v.id === areaID);
    const { children } = matched[0];
    return children;
  }

  function handleFilter(arr, t) {
    let obj = { ...val };
    if (t === 'cityCode' || t === 'areaCode') {
      if (t === 'cityCode') {
        if (arr) {
          const childrenArea = filterArea(arr[0]);
          setChildArea(childrenArea);
          obj = { ...obj, regionVo: { cityCode: arr[0] } };
        } else {
          // 全部城市则不需要参数
          setChildArea([]);
          obj = { ...obj, regionVo: {} };
        }
        setVal(obj);
        getData(obj);
      } else if (t === 'areaCode') {
        if (arr) {
          obj = { ...obj, regionVo: { ...obj.regionVo, areaCode: arr[0] } };
        } else {
          // 全部区县则只需要市级参数
          obj = { ...obj, regionVo: { cityCode: obj.regionVo.cityCode } };
        }
        setVal(obj);
        getData(obj);
      }
    } else {
      obj = { ...val, [t]: arr };
      setVal(obj);
      getData(obj);
    }
  }

  return (
    <div className="bank-product">
      <Spin spinning={loading}>
        {
          filter && (
            <div className="product-filter">
              {
                !isEmpty(data?.area) && (
                  <FilterType title="项目建设地址" titleWidth={88} data={data?.area} radio onChange={(e) => handleFilter(e, 'cityCode')} />
                )
              }
              {
                !isEmpty(childArea) && (
                  <FilterTypeChild title="" data={childArea} radio onChange={(e) => handleFilter(e, 'areaCode')} />
                )
              }
              <FilterType title="投资总金额" titleWidth={88} data={data?.dict?.SocialCapitalWebAmountStatus} onChange={(e) => handleFilter(e, 'gmtInformationStatus')} />
              <FilterType title="项目类型" titleWidth={88} data={data?.dict?.SocialCapitalProjectType} onChange={(e) => handleFilter(e, 'projectType')} />
            </div>
          )
        }
        {
          isEmpty(list?.items) ? (<EmptyImg height={300} />) : (
            <div className="product-list">
              {
                list?.items?.map((item) => (
                  <CapitalCard data={item} key={item.productId} />
                ))
              }
              <div className="pagination-box">
                <Pagination
                  showQuickJumper
                  defaultCurrent={list?.pageNum}
                  total={list?.totalRows}
                  onChange={onChange}
                />
              </div>
            </div>
          )
        }
      </Spin>
    </div>
  );
}

CapitalFilter.propTypes = {
  filter: bool,
  data: object,
};

CapitalFilter.defaultProps = {
  filter: true,
};
